import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiJavascript1,
  DiReact,
  DiPython,
  DiGit,
  DiJava,
  DiHtml5,
  DiCss3,
  DiMysql,
  DiNodejs,
  DiMongodb
} from "react-icons/di";
import {
  SiFlask,
} from "react-icons/si";

function Techstack() {
  // Estilo para el texto: muy pequeño y centrado
  const textStyle = {
    fontSize: "20px", // Esto hace el texto más pequeño que el estándar
    marginTop: "5px",  // Un poco de espacio entre el ícono y el texto
    textAlign: "center"
  };

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {/* JavaScript */}
      <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 />
        <p style={textStyle}>JavaScript</p>
      </Col>

      {/* HTML5 */}
      <Col xs={4} md={2} className="tech-icons">
        <DiHtml5 />
        <p style={textStyle}>HTML5</p>
      </Col>

      {/* CSS3 */}
      <Col xs={4} md={2} className="tech-icons">
        <DiCss3 />
        <p style={textStyle}>CSS3</p>
      </Col>

      {/* React */}
      <Col xs={4} md={2} className="tech-icons">
        <DiReact />
        <p style={textStyle}>React</p>
      </Col>

      {/* MongoDB */}
      <Col xs={4} md={2} className="tech-icons">
        <DiMongodb />
        <p style={textStyle}>MongoDB</p>
      </Col>

      {/* Node.js */}
      <Col xs={4} md={2} className="tech-icons">
        <DiNodejs />
        <p style={textStyle}>Node.js</p>
      </Col>

      {/* Git */}
      <Col xs={4} md={2} className="tech-icons">
        <DiGit />
        <p style={textStyle}>Git</p>
      </Col>

      {/* Python */}
      <Col xs={4} md={2} className="tech-icons">
        <DiPython />
        <p style={textStyle}>Python</p>
      </Col>

      {/* Java */}
      <Col xs={4} md={2} className="tech-icons">
        <DiJava />
        <p style={textStyle}>Java</p>
      </Col>

      {/* MySQL */}
      <Col xs={4} md={2} className="tech-icons">
        <DiMysql />
        <p style={textStyle}>MySQL</p>
      </Col>

      {/* Flask */}
      <Col xs={4} md={2} className="tech-icons">
        <SiFlask />
        <p style={textStyle}>Flask</p>
      </Col>
    </Row>
  );
}

export default Techstack;
